import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import CurdService from './../../admin/adminServices/curd.services'
import { setMessage } from '../../store/slices/message'

export const getImgVides = createAsyncThunk(
    'imgVides', async (id = 1, thunkAPI) => {
        const { rejectWithValue } = thunkAPI
        try {
            const res = await CurdService.get("imgcatdata", id);
            return res.data
        } catch (error) {
            const message = error.message
            thunkAPI.dispatch(setMessage(message))
            return rejectWithValue(error.message)
        }
    })


const imgVides = createSlice({
    name: 'imgTestimonials',
    initialState: { isloading: false, img: [] },
    extraReducers: (builder) => {
        builder
            // Get Testimonials Images
            .addCase(getImgVides.pending, (state, action) => {
                state.isloading = true
            })
            .addCase(getImgVides.fulfilled, (state, action) => {
                state.isloading = false;
                if (Object.keys(action.payload).length !== 0) {
                    state.img = action.payload;
                }
            })
            .addCase(getImgVides.rejected, (state, action) => {
                state.isloading = false
            })
    },
})

export default imgVides.reducer